__turbopack_context__.v({
  "className": "noto_sans_gujarati_39095417-module__4fXR8G__className",
});
